import React, { useState } from "react";
import { Container, Typography, Box, Tabs, Tab, Paper } from "@mui/material";
import ConnectorsDetails from "./ConnectorsDetails";
import EndpointDetails from "./Endpoint_details";
import PlaybookDetails from "./Playbook_details";

function ConnectorsEndpointsPlaybooks() {
  const [activeTab, setActiveTab] = useState(0); // 0 = Connectors, 1 = Endpoints, 2 = Playbooks

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 0 }}>
      <Paper
        elevation={0}
        sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}
      >
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="standard"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: "#1976d2",
              height: 3,
            },
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "16px",
              minWidth: 100,
            },
          }}
        >
          <Tab label="Connectors" />
          <Tab label="Endpoints" />
          <Tab label="Playbooks" />
        </Tabs>
      </Paper>

      {/* Tab Content */}
      <Box>
        {activeTab === 0 && <ConnectorsDetails />}
        {activeTab === 1 && <EndpointDetails />}
        {activeTab === 2 && <PlaybookDetails />}
      </Box>
    </Container>
  );
}

export default ConnectorsEndpointsPlaybooks;
